var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('h4',{staticClass:"text-primary mb-6"},[_c('strong',[_vm._v(_vm._s(_vm.$route.meta.pageTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }